import upload from "./Img/upload.svg";
import update from "./Img/update.svg";
import download from "./Img/download.svg";
import warning from "./Img/warning.svg";
import { FC, ChangeEventHandler, ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import "./DownloadButton.scss";

type ActionType = "upload" | "update" | "download";

const TOOLTIP_SX = {
    bgcolor: "#707070",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    padding: "8px 13px",
    boxShadow: "0px 4px 8px rgba(255, 244, 244, 0.1)",
};

interface DownloadButtonProps {
    onChange?: ChangeEventHandler<HTMLInputElement>;
    onDownloadClick?: () => void;
    action: ActionType;
    accept?: string;
    multiple?: boolean;
    disabled?: boolean;
    tooltipContent?: ReactNode;
}

const DownloadButton: FC<DownloadButtonProps> = ({
    onChange,
    onDownloadClick,
    action,
    accept = ".csv",
    multiple = false,
    disabled = false,
    tooltipContent,
}) => {
    const iconSrc = { upload, update, download }[action];

    const getTooltipTitle = () => {
        if (tooltipContent) return tooltipContent;
        if (action === "update") {
            return (
                <div className="download_button__tooltip_content">
                    <img src={warning} className="download_button__tooltip_icon" alt="warning" />
                    <span>
                        Download and replace existing licenses.
                        <br />
                        This action requires time!
                    </span>
                </div>
            );
        }
        if (action === "download") {
            return (
                <div className="download_button__tooltip_content">
                    <img src={warning} className="download_button__tooltip_icon" alt="warning" />
                    <span>
                        Export data to CSV.
                        <br />
                        This action requires time!
                    </span>
                </div>
            );
        }
        return "";
    };

    const handleClick = (e: React.MouseEvent) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        if (action === "download" && onDownloadClick) {
            onDownloadClick();
        }
    };

    return (
        <Tooltip
            title={!disabled ? getTooltipTitle() : ""}
            placement="bottom-start"
            slotProps={{ tooltip: { sx: TOOLTIP_SX } }}
        >
            <div className="file_input_container">
                {action !== "download" && (
                    <input
                        type="file"
                        id={`file_input_${action}`}
                        className="file_input"
                        onChange={disabled ? undefined : onChange}
                        accept={accept}
                        multiple={multiple}
                        disabled={disabled}
                        style={{ display: "none" }}
                    />
                )}

                <label
                    htmlFor={action !== "download" ? `file_input_${action}` : undefined}
                    className={`download_button ${action} ${
                        disabled ? "download_button--disabled" : ""
                    }`}
                    onClick={handleClick}
                >
                    <img src={iconSrc} alt={`${action} icon`} />
                </label>
            </div>
        </Tooltip>
    );
};

export default DownloadButton;
